import { useErpFundingForUserQuery } from 'core/graphql';

import { useDofinPermissions } from './useDofinPermissions';

/**
 * ТЗ 0024 — дофинансирование конкретного человека, для панели на карточке
 * студента.
 *
 * Запрос **пропускается** для ролей без доступа к домену, а не просто прячет
 * результат: `permissions_checker` кладёт `PermissionDenied` в `errors`, то
 * есть у HR или методиста на КАЖДОЙ карточке студента всплывала бы ошибка
 * прав от невидимой панели.
 *
 * `fundingCandidateForUser` возвращает одну заявку по детерминированному
 * порядку (закреплённая → неархивная → свежая): модель разрешает несколько
 * заявок на человека, и «какая-нибудь» здесь была бы источником расхождений
 * между обновлениями страницы.
 */
export const useFundingForUser = (userId?: string | null) => {
  const { canRead } = useDofinPermissions();
  const { data, loading, error } = useErpFundingForUserQuery({
    variables: { userId: userId || '' },
    skip: !canRead || !userId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    candidate: data?.fundingCandidateForUser ?? null,
    loading,
    error,
    canRead,
  };
};
